import { formatInTimeZone } from "@/utils/dates";
import { fetchJSON } from "./utils";
import { truncateString } from "@/utils/utils";
import { BASE_TIMEZONE } from "@/utils/constants";

function formatInteraction(interaction) {
  const STR_MAX_LEN = 30;

  const _createdAt_formatted_full_str = interaction.createdAt
    ? formatInTimeZone(
        interaction.createdAt,
        BASE_TIMEZONE,
        "hh:mm A, DD MMM YYYY"
      )
    : "Unknown Time";

  const _createdAt_formatted_readable_str = interaction.createdAt
    ? formatInTimeZone(
        interaction.createdAt,
        BASE_TIMEZONE,
        "D MMM, YYYY [at] h:mm A"
      )
    : "Unknown Date";

  return {
    ...interaction,
    _truncated_title: truncateString(interaction.query, STR_MAX_LEN),
    _createdAt_formatted_readable_str,
    _createdAt_formatted_full_str,
    _truncated_createdAt_formatted_full_str: truncateString(
      _createdAt_formatted_full_str,
      STR_MAX_LEN
    ),
    _tagSet: new Set(interaction.user_tags),
    _seenBySet: new Set(interaction.seen_by),
  };
}

export function fetchInteractions(params) {
  const url = "/api/interactions/";
  return fetchJSON(url, params, null, "get");
}

export async function updateInteraction(id, data) {
  const url = `/api/interactions/${id}`;
  const resp = await fetchJSON(url, null, data, "put");
  return formatInteraction(resp.data);
}

// interaction_ids - list of interaction ids
// read - boolean (true to mark as read, false to mark as unread)
export function markInteractionsAsReadOrUnread(interaction_ids, read) {
  const data = {
    interaction_ids: interaction_ids,
    read: read,
  };
  const url = `/api/interactions/update_read`;
  return fetchJSON(url, null, data, "put");
}

export async function getInteraction(id) {
  const url = `/api/interactions/${id}`;
  const resp = await fetchJSON(url, null, null, "get", false);
  return formatInteraction(resp.data);
}

export async function getInteractionsAround(id, params) {
  const url = `/api/interactions/${id}/around`;
  const resp = await fetchJSON(url, params, null, "get");
  return resp.data.map(formatInteraction);
}

export async function getRelevantInteractions(id) {
  const url = `/api/interactions/${id}/relevant_interactions`;
  const resp = await fetchJSON(url, null, null, "get");
  return resp.data;
}

export function getAttachmentDownloadLink(params) {
  // This endpoint returns a redirect url with content disposition already set.
  const url = `/api/interactions/download/attachment`;
  return fetchJSON(url, params, null, "get");
}

export function getS3ImageUrls(urls) {
  const data = {
    urls: urls,
  };
  const url = `/api/interactions/s3_image_urls`;
  return fetchJSON(url, null, data, "post");
}

export const createTicket = async (data) => {
  const url = `/api/interactions/create_ticket`;
  const resp = await fetchJSON(url, null, data, "post");
  return formatInteraction(resp.data);
};

export const rejectUnknownUserTicket = async (id) => {
  const url = `/api/interactions/${id}/unknown-user`;
  const resp = await fetchJSON(url, null, null, "delete");
  return resp.data;
};

export const acceptUnknownUserTicket = async (id, payload) => {
  const data = {
    known_user_id: payload.beneficiary_user_id,
    new_dept_id: payload.department_id,
    new_user_email: payload.new_user_email,
    add_email_to_user: payload.add_email_to_user,
  };
  const url = `/api/interactions/${id}/unknown-user`;
  return fetchJSON(url, null, data, "patch");
}
